import { DataLayerEvents, DatalayerPopupContentTypes } from '@/datalayer/App.datalayer.constants';
import { useImpressionPopupEvent } from '@/datalayer/hooks/useImpressionPopupEvent';

const DataLayerImpressionPopUp = ({ title = '', position = '' }) => {
  useImpressionPopupEvent({
    titleGetter: () => title,
    position,
    contentType: DatalayerPopupContentTypes.NEWS_RIBBON,
    dataLayerEventName: DataLayerEvents.DELAYED_PAGE_VIEW_EVENTS,
  });

  return null;
};

export default DataLayerImpressionPopUp;
